"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createQuestion = createQuestion;
exports.deleteQuestion = deleteQuestion;
exports.getQuestion = getQuestion;
exports.getQuestionList = getQuestionList;
exports.updateQuestion = updateQuestion;
var _request = _interopRequireDefault(require("@/utils/request"));
function updateQuestion(token, obj) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/questions/' + obj.id,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'put',
    headers,
    data: obj
  });
}
function createQuestion(token, obj) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/questions',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'post',
    headers,
    data: obj
  });
}
function deleteQuestion(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/questions/${id}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'delete',
    headers
  });
}
function getQuestion(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: `/questions/${id}`,
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers
  });
}
function getQuestionList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/questions',
    baseURL: process.env.VUE_APP_BASE_API,
    method: 'get',
    headers,
    params: query
  });
}